module.exports = __webpack_public_path__ + "static/media/feather_clock.be78b373.svg";